import { getParametrizedUrl } from '@x_x_x/utils';

import { URLS_API } from '@constants';

import { BaseApi, IRequestOptions } from '../BaseApi';

import {
	IApiMenuCatalogFetchListRequestParams,
	IApiMenuCatalogFetchListResponseData,

	IApiMenuCatalogCreateRequestParams,
	IApiMenuCatalogCreateRequestBody,
	IApiMenuCatalogCreateResponseData,

	IApiMenuCatalogUpdateRequestParams,
	IApiMenuCatalogUpdateRequestBody,
	IApiMenuCatalogUpdateResponseData,

	IApiMenuCatalogDeleteRequestParams,
} from './types';

export class MenuCatalogApi extends BaseApi {

	async fetchList(options: IRequestOptions<IApiMenuCatalogFetchListRequestParams>) {
		const { params } = options;

		return this.get<IApiMenuCatalogFetchListRequestParams, IApiMenuCatalogFetchListResponseData>({
			url: getParametrizedUrl(URLS_API.MENU_CATALOG),
			params,
		});
	}

	async create(options: IRequestOptions<IApiMenuCatalogCreateRequestParams, IApiMenuCatalogCreateRequestBody>) {
		const { body } = options;

		return this.post<IApiMenuCatalogCreateRequestBody, IApiMenuCatalogCreateResponseData>({
			url: getParametrizedUrl(URLS_API.MENU_CATALOG),
			data: body,
		});
	}

	async update(options: IRequestOptions<IApiMenuCatalogUpdateRequestParams, IApiMenuCatalogUpdateRequestBody>) {
		const { params, body } = options;

		return this.put<IApiMenuCatalogUpdateRequestBody, IApiMenuCatalogUpdateResponseData>({
			url: getParametrizedUrl(URLS_API.MENU_CATALOG_ITEM, params as unknown as Record<string, string>),
			data: body,
		});
	}

	async deleteItem(options: IRequestOptions<IApiMenuCatalogDeleteRequestParams>) {
		const { params } = options;

		return this.delete({
			url: getParametrizedUrl(URLS_API.MENU_CATALOG_ITEM, params as unknown as Record<string, string>),
		});
	}

}
